












































import Vue from 'vue'
import SignaturePad from 'signature_pad'
import { ApiResponse, Model } from '@/interfaces'
import { mapState } from 'vuex'

export default Vue.extend({
  props: {
    toggleModal: {
      type: Boolean,
      default: false,
    },
    contactId: {
      type: String,
      default: null,
    },
    items: {
      type: Array,
      required: false,
      default: () => {
        return []
      },
    },
    chosenStructure: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      showModal: false,
      chosenModel: null as number | null,
      //chosenStructure: null as number | null,
      customText: null as string | null,
      structures: [],
      busy: false,
      models: [] as Model[],
      signaturePad: null as SignaturePad | null,
    }
  },
  computed: {
    ...mapState(['user']),
    dialogWidth(): string {
      return window.innerWidth <= 768 ? '95%' : '50%'
    },
    addons(): number {
      return this.user?.client?.addons ?? 0
    },
  },
  watch: {
    toggleModal(newVal) {
      this.showModal = true
      this.$nextTick(() => {
        this.initSignaturePad()
      })
    },
    user(newVal) {
      if (newVal) {
        this.structures = newVal.client.structures
      }
    },
  },
  mounted() {
    //this.getTemplates()
    if (this.user) {
      this.structures = this.user.client.structures
    }
  },
  methods: {
    initSignaturePad() {
      const canvas = this.$refs.signatureCanvas as HTMLCanvasElement
      if (!canvas) return
      // Scale canvas for high-DPI screens (retina, mobile) to avoid blurry signatures
      const ratio = window.devicePixelRatio || 1
      canvas.width = canvas.offsetWidth * ratio
      canvas.height = canvas.offsetHeight * ratio
      const ctx = canvas.getContext('2d')
      if (ctx) ctx.scale(ratio, ratio)
      if (this.signaturePad) {
        this.signaturePad.off()
      }
      this.signaturePad = new SignaturePad(canvas, { penColor: '#000000' })
    },
    clearSignature() {
      this.signaturePad?.clear()
    },
    generateBoughtItemsDocument() {
      if (!this.busy) {
        this.busy = true
        const signatureData = this.signaturePad && !this.signaturePad.isEmpty()
          ? this.signaturePad.toDataURL('image/png')
          : null
        this.$api
          .post(`/document/${this.contactId}/contact`, {
            chosenModel: this.chosenModel,
            chosenStructure: this.chosenStructure,
            ids: this.items,
            customText: this.customText,
            signature: signatureData,
          })
          .then((response) => {
            const apiResponse = response.data as ApiResponse
            this.download(apiResponse.data.format, apiResponse.data.accessToken)
          })
          .catch((error) => {
            if (error.response) {
              const apiResponse = error.response.data as ApiResponse
              this.$notify({
                type: 'error',
                title: 'Erreur',
                message:
                  apiResponse.message ?? 'Une erreur est survenue. Veuillez nous excuser pour la gêne occasionnée.',
              })
            }
          })
          .finally(() => {
            this.busy = false
            this.showModal = false
            this.signaturePad?.clear()
          })
      }
    },
    getTemplates() {
      if (this.models.length == 0) {
        this.$api.get(`/model/contact/list`).then((response) => {
          const apiResponse = response.data as ApiResponse
          this.models = apiResponse.data
        })
      }
    },
    download(format: string, token: string) {
      let url = ''
      if (format == 'pdf') {
        url = `${process.env.VUE_APP_API_URL}/document/${token}/download?contentd=inline`
      } else {
        url = `${process.env.VUE_APP_API_URL}/document/${token}/download`
      }
      window.open(url, '_blank')
    },
  },
})
